import React from 'react'
import PropTypes from 'prop-types'
import SearchForm from './../../shared/components/searchForm/SearchForm';
import DataTable, {possibleStatus} from './../../shared/components/table/DataTable';
import {I18n} from 'react-redux-i18n';
import {terminalSearchFields} from "../utils/searchFields";
import { appModules } from '../../roles/components/UserHasPermission';

const TerminalsPage = ({
   searchFieldsValues,
   universalSearchField,
   handleSearchFieldChange,
   handleUniversalSearchFieldChange,
   handleSearchSubmit,
   handleSearchClear,
   handleSortChanged,
   handleAddButtonClicked,
   data = [],
   entityList,
   terminalProfilesList,
   onRowClick,
   pages = 0,
   currentPage = 0,
   pageSize,
   totalElements,
   sort: {
       property,
       direction
   },
   onPageChange,
   onPageSizeChange,
}) => {
    const columns = [{
        Header: I18n.t("terminals.list.terminalId"),
        accessor: "terminalIdentifier",
        sortable: true
    }, {
        Header: I18n.t("terminals.list.name"),
        accessor: "name",
        sortable: true
    }, {
        Header: I18n.t("terminals.list.entity"),
        id: "entityId.name",
        sortable: true,
        accessor: terminal => terminal.entity.name
    }, {
        Header: I18n.t("terminals.list.profile"),
        accessor: "profile",
        sortable: true
    }, {
        Header: I18n.t("terminals.list.status"),
        accessor: "status",
        sortable: true
    }, {
        Header: I18n.t("terminals.list.lastCommunication"),
        accessor: "lastCommunication",
        id: "lastCommunicationTimestamp",
        sortable: true
    }];
    return <div className="page_background">
        <SearchForm
            content={terminalSearchFields(searchFieldsValues, entityList, terminalProfilesList)}
            universalSearchField={universalSearchField}
            handleFieldChange={handleSearchFieldChange}
            handleUniversalSearchFieldChange={handleUniversalSearchFieldChange}
            handleClear={handleSearchClear}
            handleSubmit={handleSearchSubmit}
            handleAddButtonClicked={handleAddButtonClicked}
            appModule={appModules.TERMINAL}
        />
        <div>
            <DataTable
                //State dependent
                data={data}
                onRowClick={onRowClick}

                //Pagination
                pages={pages}
                selectedPage={currentPage}
                pageSize={pageSize}
                sortDirection={direction}
                sortProperty={property}
                totalElements={totalElements}
                pageSizeOptions={[10, 20, 50]}
                onPageChange={onPageChange}
                onPageSizeChange={onPageSizeChange}
                onSortChanged={handleSortChanged}

                //State independent / Configuration
                columns={columns}
                hasStatusBar={true}
                statusBarAccessor={terminal => {
                    if(terminal.online) {
                        return possibleStatus.online
                    } else {
                        return possibleStatus.offline;
                    }
                }}
            />
        </div>
    </div>
};

TerminalsPage.propTypes = {
    searchFieldsValues: PropTypes.object.isRequired,
    handleSearchFieldChange: PropTypes.func,
    handleSearchSubmit: PropTypes.func,
    handleSearchClear: PropTypes.func,
    data: PropTypes.array,
    pages: PropTypes.number,
};

export default TerminalsPage;